const workforce = [
  { name: "1-10", value: "W1_10" },
  { name: "11-30", value: "W11_30" },
  { name: "31-50", value: "W31_50" },
  { name: "51-70", value: "W51_70" },
  { name: "71+", value: "W71_PLUS" },
];

export default workforce;
